<template>
  <div class="CommentRequestComponent">

    <b-form>
    
      <b-form-group id="input-group-Remarks" :label="lang.label_Comment" >
      <b-form-textarea id="comment-Comment" class="item-form comment-textarea mb-1" rows="6" v-model="comment" size="sm" :placeholder="lang.placeholder_Comment"></b-form-textarea>
      </b-form-group>
      

    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "CommentRequestComponent",
  components: {

    

  },
  props:{
    lang: Object,
    data: Object
  },
  data () {
    return {
            
      comment: null,
      
    }
  },
  computed: {
    
    
  },
  created() {
    const obj = {
      comment: ""
    }
    this.$store.commit("SETREQUESTTASKOBJECT", obj);
    


  },
  updated() {
    const obj = {
      comment: this.comment
    }
    this.$store.commit("SETREQUESTTASKOBJECT", obj);
  },
  
  methods: {
    createUsersList(data) {

      for (let i = 0, lei = data.length; i < lei; i++) {
        

          const obj = {
            value: data[i].userId,
            text: data[i].login
          }
          
            this.usersList.push(obj);
          
          
        

      }

    }
  }
}
</script>
<style lang="scss">

  .CommentRequestComponent{
    .comment-textarea{
      height: 220px;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CommentRequestComponent.vue